import React from "react";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
import { AppEntities } from "../../../../config/entities";

const ConstructionObjectList = () => {
  const fields = [
    { title: "Id", fieldName: "id" },
    { title: "Name", fieldName: "name" },
  ];

  return (
    <>
      <NewCatalogListView
        fields={fields}
        entity={AppEntities.ConstructionObject}
      />
    </>
  );
};

export default ConstructionObjectList;
